export const INTEREST_EMAIL_SUBJECT = 'Communicator: Interest in Video Calls';